<template>
	<BasePopup
    v-model="showed"
    :maxWidth="500"
    :closeBtn="false"
    persistent
  >
    <div class="text-justify">
      <p>{{ t('customer.cancelLoginAndSignUp') }}.</p>
      <p class="my-1">
        <a
          href="javascript:void(0);"
          class="text-primary"
          @click="goToNursePage"
        >
          {{ t('common.clickHere') }}
        </a>
      </p>
      <p>{{ t('common.thank') }} !</p>
    </div>
  </BasePopup>
</template>
<script setup>
import { ref, watch } from 'vue';
import router from '@/router';
import { useCustomerCancelStore } from '@/stores/customerCancel';
import BasePopup from '@/components/Popup/Base.vue';

const customerCancelStore = useCustomerCancelStore();
const showed = ref(false);

watch(() => customerCancelStore.showedPopup, (val) => {
  if (val) {
    showed.value = val;
  }
});

watch(showed, (val) => {
  if (!val) {
    customerCancelStore.hidePopup();
  }
});

const goToNursePage = () => {
  showed.value = false;
  router.push({ name: 'Welcome' });
};
</script>
